import React from "react";
import {intl} from "dmsbasereact";

import {
    DmsAltBox,
    DmsPage,
    DmsTabber,
} from "dmsbasereact"

import { LenaPartTable } from "../../components/LenaPartTable/LenaPartTable";
// TODO: Re-enable when a Posology CRUD page exists and posologies can be created via UI.
// Currently posologies are hardcoded via fixtures, making this tab useless.
// import { PosologyPartTable } from "../../components/PosologyPartTable/PosologyPartTable";

import { Typography } from "@mui/material";

/**
 * DmsProductionPage
 * @component
 * @description Represents the page for viewing production data within a Document Management System (DMS).
 * @returns {JSX.Element} The JSX element rendering the production data management page.
 */
export const DmsProductionPage = () => {

    const tabs = [
        {
            name: "product",
            title: intl.get("Product").d("Product"),
            component: <LenaPartTable />
        },
        // TODO: Re-enable the Posology tab when posologies can be managed via UI.
        // {
        //     name: "posology",
        //     title: intl.get("Posology").d("Posology"),
        //     component: <PosologyPartTable />
        // }
    ]

    return (
        <DmsPage name={intl.get("Part").d("Product")}>
            <DmsAltBox.Card>
                <DmsAltBox.Header>
                    <Typography variant='h3' sx={{ fontSize: '1.1rem' }}>
                        {intl.get("ProductionData").d("Production Data")}
                    </Typography>
                </DmsAltBox.Header>
                <DmsAltBox.Body>
                    <DmsTabber tabs={tabs} pageName={intl.get("ProductionData").d("Production Data")} />
                </DmsAltBox.Body>
            </DmsAltBox.Card>
        </DmsPage>
    );
};